import { render, staticRenderFns } from "./modal-pendings.vue?vue&type=template&id=652ac6da&scoped=true"
import script from "./modal-pendings.vue?vue&type=script&lang=js"
export * from "./modal-pendings.vue?vue&type=script&lang=js"
import style0 from "./modal-pendings.vue?vue&type=style&index=0&id=652ac6da&prod&scoped=true&lang=css"
import style1 from "./modal-pendings.vue?vue&type=style&index=1&id=652ac6da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652ac6da",
  null
  
)

export default component.exports